<script setup>
import { addaPage } from '@/graphql/queries/metodo-adda.js'

definePageMeta({
  layout: 'default',
})

const { locale } = useI18n()

const variables = computed(() => ({
  locale: locale.value,
}))

const { data } = await useGraphql(addaPage, variables)

if (!data.value.metodoAdda) {
  throw createError({ statusCode: 404 })
}

const page = computed(() => data?.value.metodoAdda)
const ambiti = computed(() => data?.value.allListaAmbitis || [])

const seo = computed(() => page?.value.seo || {})
useSeo(seo)
</script>

<template>
  <div class="metodo-adda-page p-top-1a">
    <p v-if="page.titolo" class="intro-page-title text-3 row-270-20 max">
      {{ page.titolo }}
    </p>
    <PagineMetodoAddaIntro v-if="page.intro" :intro="page.intro" />
    <ListImageText v-if="page.adda" :blocks="page.adda" />
    <PagineMetodoAddaAccordion
      v-if="page.modelliProgettuali.length && page.titoloSezioneModelli"
      :modelli="page.modelliProgettuali"
      :title="page.titoloSezioneModelli"
    />
    <OverlapBlock
      v-if="page.bloccoSovrapposto"
      :blocco-sovrapposto="page.bloccoSovrapposto"
      type="type2"
    />
    <div class="black-bg">
      <PagineMetodoAddaTrasformazione
        v-if="ambiti && ambiti.length"
        :ambiti="ambiti"
      />
      <PagineHomeEndPageSection class="p-top-7" :with-text="false" />
    </div>
  </div>
</template>
